var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-app-bar',{attrs:{"clipped-left":"","dense":"","app":""}},[_c('v-spacer'),(_vm.isBusy)?_c('v-progress-circular',{staticStyle:{"width":"175px"},attrs:{"indeterminate":""}}):_c('img',{staticStyle:{"width":"175px"},attrs:{"src":require("../assets/logo.png"),"height":"44","title":`(c) dimedis GmbH, Köln`}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }